import { useTranslation } from 'react-i18next'
import { useCountryConfig } from './useCountryConfig'
import { getCurrencyTextLabel } from '../utils/currencyUtils'

/**
 * Localized currency text for non-icon money UIs.
 * Egypt → ج.م / EGP; Saudi → existing common.currency (ريال / SAR text).
 */
export function useCurrencyTextLabel(): string {
  const countryConfig = useCountryConfig()
  const { t } = useTranslation()
  return getCurrencyTextLabel(
    countryConfig,
    t('currency.egyptSymbol'),
    t('common.currency')
  )
}
